import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { VODCSSModules } from 'shared/utils/wix-connect';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './action-button.styl';


@VODCSSModules(styles)
export default class ActionButton extends React.Component {
  static propTypes = {
    isInFullScreen: React.PropTypes.bool,
    rounded: React.PropTypes.bool,
    icon: React.PropTypes.string,
    label: React.PropTypes.any,
    onClick: React.PropTypes.func,
    children: React.PropTypes.element,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    rounded: false,
    onClick: _.noop,
  };

  componentDidMount() {
    this.attachNativeEvents();
  }

  componentWillUnmount() {
    this.unattachNativeEvents();
  }

  @autobind
  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();

    this.props.onClick();
  }

  @autobind
  setActionNodeRef(node) {
    this.node = node;
  }

  attachNativeEvents() {
    this.node.addEventListener('click', this.handleClick);
  }

  unattachNativeEvents() {
    this.node.removeEventListener('click', this.handleClick);
  }

  get label() {
    const { label } = this.props;
    if (!label) {
      return null;
    }

    return (
      <span styleName="label">{label}</span>
    );
  }

  render() {
    const { rounded, label, icon, className, isInFullScreen } = this.props;

    const styleNames = classnames('action-button', icon, {
      rounded,
      'with-label': Boolean(label),
      'at-full-screen': isInFullScreen,
    });

    return (
      <a href=""
         styleName={styleNames}
         className={className}
         onClick={this.handleClick}
         ref={this.setActionNodeRef}>
        {this.label}
        <Icon styleName="icon"
              name={icon} />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/action-button/action-button.js